import { Directive, Input, ElementRef, OnDestroy } from '@angular/core';
import { FloatingNavigationService } from '../../../shell/services/floating-navigation/floating-navigation.service';
import { Subscription } from 'rxjs';
import { FloatingNavigationModel } from '../../../shell/models/floating-navigation.model';

@Directive({
  selector: '[dlsRightSideNav], dls-right-side-nav',
})
export class RightSideNavDirective implements OnDestroy {

  elementPosition: number;
  floatingNav: FloatingNavigationModel[];
  private isViewChanged$: Subscription;
  private previousHeight: number;
  private currentHeight: number;
  private _offset: number;

  @Input() public title: string;
  @Input() public level: number;
  @Input()
  set offset (offset: number) {
    this._offset = offset * -1;
  }
  get offset (): number {
    return this._offset;
  }

  @Input() public id: string;

  constructor(
    private _el: ElementRef,
    private floatingNavigationService: FloatingNavigationService) {
    this.level = 0;
    this.floatingNav = [];
    this.offset = 0;
    this.previousHeight = this.currentHeight = 0;

    this.isViewChanged$ = this.floatingNavigationService
      .isViewHeightChanged()
      .pipe(
        // Delay to load the components view
      ).subscribe((isForced) => {
        // Preserve the previous offset top
        this.previousHeight = this.currentHeight;

        // Update the current offset top
        this.currentHeight = this._el.nativeElement.offsetTop;

        /**
         * Update height only when change in offset height is present
         */
        if (this.currentHeight !== this.previousHeight || isForced) {
          if (this.title && this.id) {
            this.floatingNavigationService.setNavItem({
              title: this.title,
              elementOffsetTop: (this._el.nativeElement.offsetTop + this.offset),
              indentIndex: this.level,
              id: this.id
            });
          }
        }
      });
  }

  ngOnDestroy (): void {
    this.isViewChanged$.unsubscribe();
  }
}
